 <template>
 <div class="print">
          <div
            id="subapp-viewport-toolbar"
            class="subApp flex sm:justify-between xl:flex-nowrap items-center"
          >
            <div class="flex flex-col sm:flex-row w-full gap-4 pt-4">
              <div class="" id="search-container"></div>
              <div class="flex flex-row flex-wrap gap-4 justify-between w-full">
                <div class="flex flex-row flex-wrap gap-4">
                  <div id="sort-container"></div>
                  <div id="column-container"></div>
                  <div id="filter-button"></div>
                </div>
                <div class="flex flex-row flex-wrap gap-4">
                <div id="button-container"></div>
                <div id="export-container"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row w-full mt-4">
            <div id="filter-container"></div>
            <div id="datalist-container"></div>
          </div>
          <div id="sub_app_1" class="subApp"></div>
          <div id="subapp-viewport-pagination" class="subApp"></div>
          <div id="multipart-form-container"></div>
        </div>
        </template>
<style scoped>
.print {
background-color: white;
}
</style>